module.exports = __webpack_public_path__ + "static/media/circle-black.37fd6338.png";